import { atom } from "jotai";

import { AuthUserAtom } from "@/states/auth/types";

export const authUserAtom = atom<AuthUserAtom>({
  user: undefined,
  isLoading: false,
  isInitialized: false,
  error: undefined,
});
